import { useContext, useState, FC, useEffect } from 'react'

import { Role, RoleFilterKeyString } from 'Attendances/types'
import { ROLE_INITIAL_FILTER } from 'Attendances/constants/pages/roles'
import CustomFormRoleSelectionDrawerManagerContext from './Context'
import readRolesOnCustomForm from './services/readRolesOnCustomForm'

type Props = {
  questionKey: string
  children: JSX.Element
}

const CustomFormRoleSelectionDrawerManagerProvider: FC<Props> = ({ questionKey, children }) => {
  const [view, setView] = useState<string>('SEARCH_ROLE')
  const [selectedRole, setSelectedRole] = useState<Role>({})
  const [loadingRoles, setLoadingRoles] = useState<boolean>(true)
  const [roles, setRoles] = useState<Role[]>([])
  const [filter, setFilter] = useState<RoleFilterKeyString>(ROLE_INITIAL_FILTER)

  async function loadRole() {
    setLoadingRoles(true)
    const filters = {
      filter,
      pagination: {
        page: 1,
        limit: 0,
      },
    }

    const response = await readRolesOnCustomForm({ filters })

    if (response?.header?.success) {
      const rolesFromAPI = response?.body?.role?.elements
      setRoles(rolesFromAPI || [])
    }
    setLoadingRoles(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_ROLE') loadRole()
  }, [filter])

  return (
    <CustomFormRoleSelectionDrawerManagerContext.Provider
      value={{
        view,
        setView,
        selectedRole,
        setSelectedRole,
        filter,
        setFilter,
        questionKey,
        roles,
        loadingRoles,
        setLoadingRoles,
      }}
    >
      {children}
    </CustomFormRoleSelectionDrawerManagerContext.Provider>
  )
}

export const useCustomFormRoleSelectionDrawerManager = () => useContext(CustomFormRoleSelectionDrawerManagerContext)

export default CustomFormRoleSelectionDrawerManagerProvider
